import React, { useState } from "react";
import { TextField, Button, Box, Typography } from "@mui/material";
import { checkOper_or_admin } from "../utils/tool";

const sxTextField = {
  m: 0.5,
  "& .MuiOutlinedInput-root": {
    borderRadius: "8px",
    fontSize: 13,
  },
  "& .MuiInputLabel-root": {
    fontSize: 13,
  },
};

export default function AccomInput(props) {
  const [init_data, set_init_data] = useState(props.init_data);

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
      {checkOper_or_admin() ? (
        <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
          {props.init_data.hide ? (
            <Button
              size="small"
              variant="contained"
              color="success"
              sx={{
                borderRadius: "20px",
                textTransform: "none",
                fontWeight: 500,
                fontSize: 13,
              }}
              onClick={() => {
                props.onShowClick(props.init_data._id);
              }}
            >
              Show
            </Button>
          ) : (
            <Button
              size="small"
              variant="outlined"
              color="error"
              sx={{
                borderRadius: "20px",
                textTransform: "none",
                fontWeight: 500,
                fontSize: 13,
              }}
              onClick={() => {
                props.onHideClick(props.init_data._id);
              }}
            >
              Hide
            </Button>
          )}
        </Box>
      ) : null}

      <Box sx={{ display: "flex", gap: 1 }}>
        <TextField
          sx={{ ...sxTextField, flex: 1 }}
          size="small"
          id="code"
          label="Code"
          variant="outlined"
          value={init_data.code}
          onChange={(e) =>
            set_init_data({ ...init_data, code: e.target.value })
          }
        />
        <TextField
          sx={{ ...sxTextField, flex: 1 }}
          size="small"
          id="city"
          label="City"
          variant="outlined"
          value={init_data.city}
          onChange={(e) =>
            set_init_data({ ...init_data, city: e.target.value })
          }
        />
      </Box>

      <TextField
        sx={{ ...sxTextField, flex: 4 }}
        size="small"
        id="hotel"
        label="Hotel"
        variant="outlined"
        multiline
        minRows={2}
        value={init_data.hotel}
        onChange={(e) => set_init_data({ ...init_data, hotel: e.target.value })}
      />
      <TextField
        sx={{ ...sxTextField, flex: 4 }}
        size="small"
        id="address"
        label="Address"
        variant="outlined"
        value={init_data.address}
        onChange={(e) =>
          set_init_data({ ...init_data, address: e.target.value })
        }
      />

      <Typography
        sx={{ fontSize: 13, fontWeight: 600, color: "#555", mt: 0.5 }}
      >
        Details
      </Typography>
      <Box sx={{ display: "flex", gap: 1 }}>
        <TextField
          sx={{ ...sxTextField, flex: 3 }}
          size="small"
          id="type"
          label="Type"
          variant="outlined"
          value={init_data.type}
          onChange={(e) =>
            set_init_data({ ...init_data, type: e.target.value })
          }
        />
        <TextField
          sx={{ ...sxTextField, flex: 3 }}
          size="small"
          id="status"
          label="Status"
          variant="outlined"
          value={init_data.status}
          onChange={(e) =>
            set_init_data({ ...init_data, status: e.target.value })
          }
        />
        <TextField
          sx={{ ...sxTextField, flex: 3 }}
          size="small"
          id="remark"
          label="Remark"
          variant="outlined"
          value={init_data.remark}
          onChange={(e) =>
            set_init_data({ ...init_data, remark: e.target.value })
          }
        />
      </Box>

      <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 1 }}>
        <Button
          variant="contained"
          disableElevation
          sx={{
            borderRadius: "20px",
            textTransform: "none",
            fontWeight: 500,
            fontSize: 13,
            px: 4,
          }}
          onClick={() => {
            props.onSaveClick(props.init_data._id, init_data);
          }}
        >
          Save
        </Button>
      </Box>
    </Box>
  );
}
